export const isEnhancedPhotoCaptureEnabled = () => {
    return false;
    // return EnvironmentService.getEnvironmentName() === Environment.DEV;
};
const MODULE_PREFIX = 'FILE_UPLOAD';
export const FILE_UPLOAD_ALL_FILES_UPLOAD_START = `${MODULE_PREFIX}_ALL_FILES_UPLOAD_START`;
export const FILE_UPLOAD_RETRY_FILES_UPLOAD_START = `${MODULE_PREFIX}_RETRY_FILES_UPLOAD_START`;
export const FILE_UPLOAD_SINGLE_FILE_UPLOAD_START = `${MODULE_PREFIX}_SINGLE_FILE_UPLOAD_START`;
export const FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE = `${MODULE_PREFIX}_SINGLE_FILE_UPLOAD_COMPLETE`;
export const FILE_UPLOAD_SINGLE_FILE_UPLOAD_PROGRESS = `${MODULE_PREFIX}_SINGLE_FILE_UPLOAD_PROGRESS`;
export const FILE_UPLOAD_SINGLE_FILE_UPLOAD_SUCCESS = `${MODULE_PREFIX}_SINGLE_FILE_UPLOAD_SUCCESS`;
export const FILE_UPLOAD_SCALE_IMAGE_COMPLETE = `${MODULE_PREFIX}_SCALE_IMAGE_COMPLETE`;
export const FILE_UPLOAD_ADD_SINGLE_FILE = `${MODULE_PREFIX}_ADD_SINGLE_FILE`;
export const FILE_UPLOAD_ALL_FILES_UPLOAD_SUCCESS = `${MODULE_PREFIX}_ALL_FILES_UPLOAD_SUCCESS`;
export const FILE_UPLOAD_CLOSE_MODAL = `${MODULE_PREFIX}_CLOSE_MODAL`;
export const FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL = `${MODULE_PREFIX}_SINGLE_FILE_UPLOAD_CANCEL`;
export const allFilesUploadStartAction = uploadFilesActionPayload => ({
    type: FILE_UPLOAD_ALL_FILES_UPLOAD_START,
    payload: uploadFilesActionPayload
});
export const retryFilesUploadStartAction = uploadFilesActionPayload => ({
    type: FILE_UPLOAD_RETRY_FILES_UPLOAD_START,
    payload: uploadFilesActionPayload
});
export const allFilesUploadSuccessAction = isMobile => ({
    type: FILE_UPLOAD_ALL_FILES_UPLOAD_SUCCESS,
    payload: {
        isMobile,
        isEnhancedPhotoCaptureEnabled: isEnhancedPhotoCaptureEnabled()
    }
});
export const closeFileUploadModalAction = () => ({
    type: FILE_UPLOAD_CLOSE_MODAL,
    payload: {}
});
export const singleFileUploadStartAction = id => ({
    type: FILE_UPLOAD_SINGLE_FILE_UPLOAD_START,
    payload: { id }
});
export const singleFileUploadCompleteAction = payload => ({
    type: FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE,
    payload
});
export const singleFileUploadProgressAction = payload => ({
    type: FILE_UPLOAD_SINGLE_FILE_UPLOAD_PROGRESS,
    payload
});
export const singleFileUploadSuccessAction = payload => ({
    type: FILE_UPLOAD_SINGLE_FILE_UPLOAD_SUCCESS,
    payload
});
export const scaleImageCompleteAction = (id, success, file) => ({
    type: FILE_UPLOAD_SCALE_IMAGE_COMPLETE,
    payload: { id, success, file }
});
export const addSingleFileAction = fileInfo => ({
    type: FILE_UPLOAD_ADD_SINGLE_FILE,
    payload: { fileInfo: fileInfo }
});
export const singleFileUploadCancelAction = id => ({
    type: FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL,
    payload: { id }
});
//# sourceMappingURL=FileUploadActions.js.map